import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              韩国漫画网
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最优质的韩漫在线阅读平台，提供免费、无删减的韩国漫画资源，持续更新，让您尽情享受韩漫的魅力。
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  恋爱韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  奇幻韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  动作韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/healing" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  治愈韩漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              如有任何问题或建议，欢迎通过关于我们页面的联系方式与我们取得联系，我们将尽快回复您。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国漫画网 - 韩漫在线阅读平台. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}